import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import WaitingModal from '../../generics/WaitingModal';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalViewInformation extends Component{
	constructor(props){
		super(props);

		this.state = {
			show: false,

			donation:{},
			donation_session:"",
			offer:{},
			offer_birthday:"",
			offer_age :"",
			offer_document_type:"",
			offer_document:{},
			offer_address:{},
			offer_mpio:{},
			offer_state:{},

			patient:{},
			national_center:"",
			patient_person:{},

			show_patient_data:false,

			day_sessions:[],
			day_sesion_donation:"",
			caller_id:""
		}

		this.handleShow  = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleShow(offer_id, caller_id){
		this.setState({
			show:true,
			caller_id:caller_id
		});

		this.waiting_modal.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'offers/'+offer_id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			const donation = {
				register_date: response.timestamp_date+' '+response.timestamp_hour,
				convoke_place: response.convoke_places_name,
				type_extraction: response.type_extraction_name,
				type_donation: response.type_donation_name,
			};

			this.setState({
				donation: donation
			})
			
			this.getDonor(response.item, response.timestamp_date, response.timestamp_hour);
			//this.setState({donor_id:response.item.donor_id,offer_id:response.item.id})
			
		})

	}

	getDonor(offer, timestamp_date, timestamp_hour){
  		//Get Offer
		fetch(Config.default.apiGateway.URL+'donors?id='+offer.donor_id+'&offer_id='+offer.id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {

			let birth = response.person.birthday.split('T')[0];

			//calcular edad

			this.setState({
				offer 			: response.person,

				offer_birthday  : birth.split('-').reverse().join('/'),
				offer_document_type : response.document.document_type_value,
				offer_document 	: response.document.document,
				offer_address  	: response.address,
				offer_mpio 		: response.mpio,
				offer_state 	: response.state,
				
			});


			if(response.person_patient !== null){ 
				this.setState({
					patient 		: response.patient,
					national_center : response.national_center ? response.national_center.name : "",
					patient_person 	: response.person_patient,
					show_patient_data: true,
				});
			}else{
				this.setState({show_patient_data:false});
			}


			this.calcularEdad(this.state.offer_birthday);
			this.waiting_modal.handleClose();

		})


		//Consultar el turno correspondiente y mostrarlo
		fetch(Config.default.apiGateway.URL+'work_sessions/?option=&health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({day_sesion_donation:response.id});
		})

		//day_sessions
		fetch(Config.default.apiGateway.URL+'work_sessions/'+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      day_sessions: response
		    });

			setTimeout(function(){
				this.setSession(this.state.day_sessions, this.state.day_sesion_donation)
			}.bind(this), 500);
		})
  	}

  	setSession(sessions, id_session){
  		var session_val = "";
  		sessions.map(function(i){
  			if(i.id === id_session){
  				session_val = i.type_value;
  			}
  		})

  		this.setState({
			donation_session:session_val
		})
  	}

	handleClose(){
	    this.setState({ show: false});    
	}

	calcularEdad(birthday){
		var hoy = new Date();
		var cumpleanos = new Date(birthday.split(/\//).reverse().join('/'));
		if(cumpleanos.toString() !== 'Invalid Date'){
			var edad = hoy.getFullYear() - cumpleanos.getFullYear();
			var m = hoy.getMonth() - cumpleanos.getMonth();

		    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
		        edad--;
		    }
		    this.setState({offer_age:edad});
		}
	}	

	render(){
		const { t } = this.props;

		return (
			<div>				
				<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
					<Modal.Header closeButton>
						<Modal.Title>Detalles</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div style={{padding:"0.5em"}}>
							<fieldset>
								<legend style={{fontSize:"1.2em"}}>Datos Donación</legend>
								<div className="row form-group">
									<div className="col-xs-12 col-md-2 col-sm-4">
										<span>{t('content.offers.form.timestamp')}</span>
										<input type="text" className="form-control" value={this.state.donation.register_date || ""} disabled />
									</div>

									<div className="col-xs-12 col-md-2 col-sm-4">
										<span>{t('content.offers.form.day_session')}</span>
										<input type="text" className="form-control" value={this.state.donation_session || ""} disabled />
									</div>

									<div className="col-xs-12 col-md-2 col-sm-4">
										<span>{t('content.offers.form.convoke_place')}</span>
										<input type="text" className="form-control" value={this.state.donation.convoke_place || ""} disabled />
									</div>

									<div className="col-xs-12 col-md-2 col-sm-4">
										<span>{t('content.offers.form.extraction_type')}</span>
										<input type="text" className="form-control" value={this.state.donation.type_extraction || ""} disabled />
									</div>

									<div className="col-xs-12 col-md-4 col-sm-4">
										<span>{t('content.offers.form.donation_type')}</span>
										<input type="text" className="form-control" value={this.state.donation.type_donation || ""} disabled />
									</div>
								</div>
							</fieldset>

							<fieldset>
								<legend style={{fontSize:"1.2em"}}>Datos del Donador</legend>
								<div>
									<div className="row form-group">
										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.document_type')}</span>
											<input type="text" className="form-control" value={this.state.offer_document_type || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.number')}</span>
											<input type="text" className="form-control" value={this.state.offer_document.document_number || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.gender')}</span>
											<input type="text" className="form-control" value={this.state.offer.sex || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.civil_status')}</span>
											<input type="text" className="form-control" value={this.state.offer.civil_status || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.birthday')}</span>
											<input type="text" className="form-control" mask='11/11/1111' value={this.state.offer_birthday || ""} onChange={(e)=>(this.calcularEdad(e, ))} disabled />
										</div>

										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.age')}</span>
											<input type="text" className="form-control" value={this.state.offer_age || ""} disabled />
										</div>
									</div>

									<div className="row form-group">
										<div className="col-xs-12 col-md-4 col-sm-4">
											<span>{t('content.offers.form.names')}</span>
											<input type="text" className="form-control" value={this.state.offer.names || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.lastname1')}</span>
											<input type="text" className="form-control" value={this.state.offer.lastname1 || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.lastname2')}</span>
											<input type="text" className="form-control" value={this.state.offer.lastname2 || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-4 col-sm-8">
											<span>{t('content.offers.form.scholarship')}</span>
											<input type="text" className="form-control" value={this.state.offer.scholarship || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-4 col-sm-4">
											<span>{t('content.offers.form.job_profile')}</span>
											<input type="text" className="form-control" value={this.state.offer.job_profile || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-4 col-sm-8">
											<span>{t('content.offers.form.email')}</span>
											<input type="text" className="form-control" value={this.state.offer.email || ""} disabled />
										</div>
									</div>

								
									<div className="row form-group">
										<div className="col-xs-12 col-md-8 col-sm-8">
											<span>{t('content.generics.address.street')}</span>
											<input type="text" className="form-control" value={this.state.offer_address.street || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-4 col-sm-4">
											<span>{t('content.generics.address.postal_code')}</span>
											<input type="text" className="form-control" value={this.state.offer_address.postal_code || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-4 col-sm-4">
											<span>{t('content.generics.address.mpio')}</span>
											<input type="text" className="form-control" value={this.state.offer_mpio.value_name || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-4 col-sm-4">
											<span>{t('content.generics.address.state')}</span>
											<input type="text" className="form-control" value={this.state.offer_state.value_name || ""} disabled />
										</div>
									</div>
								</div>
							</fieldset>
							{/*si show_patient es true mostrar lo siguiente*/}
							{this.state.show_patient_data ?
								<fieldset>
									<legend style={{fontSize:"1.2em"}}>Datos del Paciente</legend>
									<div className="row form-group">
										<div className="col-xs-12 col-md-4 col-sm-4">
											<span>{t('content.offers.form.names')}</span>
											<input type="text" className="form-control" value={this.state.patient_person.names || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.lastname1')}</span>
											<input type="text" className="form-control" value={this.state.patient_person.lastname1 || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.lastname2')}</span>
											<input type="text" className="form-control" value={this.state.patient_person.lastname2 || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.no_file')}</span>
											<input type="text" className="form-control" value={this.state.patient.number || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-2 col-sm-4">
											<span>{t('content.offers.form.rh_group')}</span>
											{this.state.patient.lookup_group}
											<input type="text" className="form-control" value={this.state.patient_person.lookup_rh === 'POSITIVO' ? this.state.patient_person.lookup_group+' +' : this.state.patient_person.lookup_group+' -'} disabled />
										</div>


										<div className="col-xs-12 col-md-4 col-sm-4">
											<span>{t('content.offers.form.health_facility')}</span>
											<input type="text" className="form-control" value={this.state.national_center || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-4 col-sm-4">
											<span>{t('content.offers.form.service')}</span>
											<input type="text" className="form-control" value={this.state.patient.national_name || ""} disabled />
										</div>

										<div className="col-xs-12 col-md-4 col-sm-4">
											<span>{t('content.offers.form.relationship')}</span>
											<input type="text" className="form-control" value={this.state.patient.relationship || ""} disabled />
										</div>

									</div>
								</fieldset>
								:null
							}
						</div>
					</Modal.Body>
					<Modal.Footer>
			        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
			        </Modal.Footer>
				</Modal>
				

				<WaitingModal {...this.props} onRef={ref=>this.waiting_modal = ref} />
			</div>
		)
	}
}

export default ModalViewInformation;